import * as React from 'react';
import { useState, useEffect } from "react";
import { logout } from "../../../redux/actions/userActions";
import { useDispatch } from "react-redux";
import { Link as LinkReact } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

const config = require("../../../constants/constants.js")

const AdminCustomersPageComponent = ({ fetchCustomers, deleteCustomer }) => {

  const [customers, setCustomers] = useState([]);
  const [customerDeleted, setCustomerDeleted] = useState(false);
  const dispatch = useDispatch();

  const [finalClickInfo, setFinalClickInfo] = useState(null);

  // --- INI -------  Confirm Dialog
  const [idCustomerInWorking, setIdCustomerInWorking] = useState("");
  const [nameInWorking, setNameInWorking] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const PopupConfirmConfirm = async () => {
    console.log('[PopupConfirmConfirm]')
    const data = await deleteCustomer(idCustomerInWorking)
    if (data.message === "customer removed") {
      setCustomerDeleted(!customerDeleted);
    }
    window.location.assign('/admin/customers')
    setOpen(false);
    window.location.assign('/admin/customers')
  };

  const PopupConfirmClose = () => {
    console.log('[PopupConfirmClose]')
    setOpen(false);
  };

  const ViewConfirmDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={PopupConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ background: "#4bf5cc", fontWeight: "bold" }}>
          {"Cancellazione cliente"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            Confermi la cancellazione del cliente <b><i>{nameInWorking}</i></b> ?
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="small"
            color="warning"
            onClick={PopupConfirmClose}>
            Annulla
          </Button>
          <Button
            variant="contained"
            size="small"
            color="success"
            onClick={PopupConfirmConfirm}
            autoFocus
          >
            Conferma
          </Button>
        </DialogActions>

      </Dialog>
    );
  };
  // --- FIN -------  Confirm Dialog

  const handleOnCellClick = (params) => {
    setFinalClickInfo(params);
    console.log('onclick params=', params)
    console.log('onclick params riga =', params.id)
    console.log('onclick params titoloColonna =', params.field)
  };

  const deleteHandler = async (customerId) => {
    if (window.confirm("Sei sicuro?")) {
      const data = await deleteCustomer(customerId)
      if (data.message === "customer removed") {
        setCustomerDeleted(!customerDeleted);
      }
      //navigate("/admin/customers");
      window.location.assign('/admin/customers')
    }
  };

  const paginationModel = { page: 0, pageSize: 5 };

  const columns = [
    { field: 'title', headerName: 'Titolo', type: 'string', width: 150, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'name', headerName: 'Nome', type: 'string', width: 150, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'surname', headerName: 'Cognome', type: 'string', width: 150, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'mobile', headerName: 'Mobile', type: 'string', width: 120, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'email', headerName: 'Email', type: 'string', width: 250, editable: false, sortable: false, headerAlign: 'center' },
    {
      field: "actions",
      type: "actions",
      headerName: 'Azioni',
      hide: true,
      width: 100,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          title="modifica"
          component={LinkReact}
          to={`/admin/edit-customer/${params.id}`}
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          title="cancella"
          onClick={() => {
            setIdCustomerInWorking(params.id)
            setNameInWorking(params.row.name + " " + params.row.surname)
            handleClickOpen();
          }}
        />
      ]
    },
    { field: 'telephone', headerName: 'Telefono', type: 'string', width: 120, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'via', headerName: 'Via', type: 'string', width: 150, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'cap', headerName: 'Cap', type: 'string', width: 80, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'citta', headerName: 'Città', type: 'string', width: 130, editable: false, sortable: false, headerAlign: 'center' },
    { field: 'provincia', headerName: 'Prov', type: 'string', width: 50, editable: false, sortable: false, headerAlign: 'center' },
  ];

  useEffect(() => {
    const abctrl = new AbortController();
    fetchCustomers(abctrl)
      .then((res) => setCustomers(res))
      .catch((er) =>
        dispatch(logout())
      );
    return () => abctrl.abort();
  }, [customerDeleted]);

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_CUSTOMERS}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{
              flexDirection: { xs: "row", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Clienti</b>&nbsp;
            </Typography>

            <Button
              variant="contained"
              size="small"
              sx={{ 
                maxWidth: "30ch",
                maxHeight: "4ch"
               }}
              href='/admin/create-new-customer'
            >
              Crea cliente
            </Button>

          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 10
            }}
          />

          <Box sx={{ height: 350, width: '100%', paddingTop: 2, paddingLeft: 0 }}>

            <DataGrid
              showToolbar
              getRowId={(row) => row._id}
              rows={customers}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5
                  },
                },
              }}
              pageSizeOptions={[5]}
              disableRowSelectionOnClick
              columnHeaderHeight={40}
              rowHeight={40}

              sx={{
                '& .MuiDataGrid-columnHeader':
                {
                  backgroundColor: "cyan",
                  color: "black",
                  border: 2,
                  boxShadow: 1,
                  fontWeight: 700,
                },
                '& .MuiDataGrid-cell':
                {
                  backgroundColor: "lightcyan",
                  color: "gray",
                  border: 1,
                  boxShadow: 1,
                  fontWeight: 300,
                },
                '& .MuiDataGrid-cell:hover':
                {
                  backgroundColor: "#b0c0e5",
                  color: 'primary.main',
                },
                '&.Mui-selected':
                {
                  color: 'primary.main',
                }

              }} />
          </Box>

          < ViewConfirmDialog />

        </Box>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 40
        }}
      />

    </Box>

  );
};

export default AdminCustomersPageComponent;
